// extracted by mini-css-extract-plugin
export var brightBlue = "Tiles-module--brightBlue--82bde";
export var darkBlue = "Tiles-module--darkBlue--8f45f";
export var expanded = "Tiles-module--expanded--37c19";
export var imageBg = "Tiles-module--imageBg--50c82";
export var seaGreen = "Tiles-module--seaGreen--d60c9";
export var tile = "Tiles-module--tile--708f2";
export var tileContainer = "Tiles-module--tileContainer--df694";
export var tiles = "Tiles-module--tiles--18030";
export var title = "Tiles-module--title--92085";